import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = "查看全部" }: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <h2 className="font-heading text-foreground-50 text-xl md:text-2xl font-bold flex items-center gap-3">
          <span className="w-1 h-6 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-400 font-label mt-2">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 font-label shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}